import toast from 'reusable-components/notifications/toast';
import { create } from 'zustand';

type DebugModeState = {
  debugMode: boolean;
  logAnalytics: boolean;
  setDebugMode: (newMode: boolean) => void;
  toggleLogAnalytics: () => void;
};
export const useDebugModeStore = create<DebugModeState>()((set, get) => ({
  debugMode: DEBUG,
  logAnalytics: false,
  toggleLogAnalytics: () => {
    const newMode = !get().logAnalytics;
    toast({
      toastId: 'debug-mode-toast',
      text: `Analytics logging is now ${newMode ? 'enabled' : 'disabled'}.`,
      position: 'bottom-center',
    });
    set({ logAnalytics: newMode });
  },
  setDebugMode: (newMode) => {
    toast({
      toastId: 'debug-mode-toast',
      text: `Debug mode is now ${newMode ? 'enabled' : 'disabled'}.`,
      position: 'bottom-center',
    });
    set({ debugMode: newMode });
  },
}));
